/* eslint-disable prettier/prettier */
/* eslint-disable */

import { connectReducers } from '../../utils';

import { GET_STUDENT_CHECKIN_HISTORY } from '../../actions';

import { FAILURE, INVALIDATE, REQUEST, SUCCESS } from '../../actions/utils';

import { ICommonResponse, IStudentCheckInHistory } from '../../api/types';

import genericReducers from '../genericReducer';

import { IReducers } from '..';

export type StudentCheckInHistoryState = ICommonResponse<IStudentCheckInHistory>;

const initialState = {
  content: [],
  loading: false,
} as ICommonResponse<IStudentCheckInHistory>;
const generic = genericReducers<StudentCheckInHistoryState>();
const studentCheckInHistory: IReducers<StudentCheckInHistoryState> = {
  [GET_STUDENT_CHECKIN_HISTORY[REQUEST]]: generic.get.request,
  [GET_STUDENT_CHECKIN_HISTORY[SUCCESS]]: generic.get.success,
  [GET_STUDENT_CHECKIN_HISTORY[FAILURE]]: generic.get.failure,
  [GET_STUDENT_CHECKIN_HISTORY[INVALIDATE]]: generic.get.invalidate(initialState),
};

export default connectReducers(initialState, studentCheckInHistory);
